module.exports = __webpack_public_path__ + "img/peo_1.6a651811.png";